import { render, staticRenderFns } from "./CompaniesFound.vue?vue&type=template&id=23cddc2a&"
import script from "./CompaniesFound.vue?vue&type=script&lang=js&"
export * from "./CompaniesFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports